// ⚠️ THE DB-IP LICENCE (CC BY 4.0) NEEDS THIS on every screen that shows a location
// (services/geo.py). `securityWords.checks.mjs` and backend `test_security_log.py` fail if a
// screen showing countries loses it.
import React from 'react';

export default function SecurityCredit({ credit }) {
  const text = (credit && credit.text) || 'IP Geolocation by DB-IP';
  const url = (credit && credit.url) || 'https://db-ip.com';
  return (
    <p className="text-[11px] text-muted-foreground/70 mt-3">
      <a href={url} target="_blank" rel="noopener noreferrer" className="hover:underline">{text}</a>
    </p>
  );
}
